import { FilesPickerInput } from "../../../../Files/shared/FilesPickerInput.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import { useMemo } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Files/Form.tsx
var FilesFieldForm = ({ config }) => {
	const { fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	const allowedTypes = useMemo(() => {
		/** When true the user can only use in-app camera/video */
		if (config.options.noFilesAndGalleryPicker) return ["cameraCapture", "videoCapture"];
		return [
			"cameraCapture",
			"filePicker",
			"imagePicker",
			"videoCapture"
		];
	}, [config]);
	return /* @__PURE__ */ jsx(FilesPickerInput, {
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		allowedTypes,
		label: config.options.label || config.options.formLabel,
		multi: !!config.options.multi,
		onChangeValue: (val) => fieldValueChanged(config.id, val),
		previouslyUploadedFileUrls: valuesByFieldId[config.id],
		subText: config.options.subText
	});
};
//#endregion
export { FilesFieldForm };

//# sourceMappingURL=Form.js.map